export default __webpack_public_path__ + "static/media/login-bg-26.6fce7675.jpg";